module.exports = __webpack_public_path__ + "static/structure-3d-immeuble-geometry-880x880-61c392981ff8e3a49ceadb801fb7330d.png";